import styled from 'styled-components';

export const Container = styled.div`
  margin: 0px 10%;
  hr {
    margin-top: 2%;
    height: 1px;
  }
`;
